<template>
  <div class="position-relative fill-width">
    <div class="pa-5 grey lighten-5 position-relative overflow-hidden">
      <template v-if="onCredit">
        <div class="text-title py-2 font-weight-bold">
          {{ $store.getters['request/monthlyAmount'] | currency }} / mo
        </div>
        <v-divider></v-divider>
        <div class="text-title py-2">
          {{ $store.getters['request/noOfMonths'] }} month(s)
        </div>
        <v-divider></v-divider>
        <div class="text-title py-2 d-flex align-center">
          {{ $store.getters['request/upfrontAmount'] | currency }} upfront
          <v-chip class="teal--text ml-2" color="teal lighten-5" dark small v-if="request.upfront_paid === 1">
            Paid
          </v-chip>
          <v-chip class="red--text ml-2" color="red lighten-5" dark small v-if="request.upfront_paid === 0">
            Not paid
          </v-chip>
        </div>
      </template>
      <template v-else>
        <div class="text-title mb-1 d-flex align-center font-weight-bold">
          {{ request.cred_plus_upfront | currency }}
          <v-chip class="teal--text ml-2" color="teal lighten-5" dark small v-if="request.upfront_paid === 1">
            Paid
          </v-chip>
          <v-chip class="red--text ml-2" color="red lighten-5" dark small v-if="request.upfront_paid === 0">
            Not paid
          </v-chip>
        </div>
      </template>
      <RequestStatus @open="$emit('open', $event)"/>
      <v-icon class="bg-cart" size="100">mdi-cart</v-icon>
    </div>

    <v-divider/>

    <p class="py-8 px-6" v-if="!request.items.length">
      <v-icon class="mr-2" size="18">mdi-alert-circle-outline</v-icon>
      Items will be added by merchant
    </p>
    <div class="pa-5" v-else>
      <div class="d-flex justify-space-between align-center">
        <span>Item</span>
        <span>Amount</span>
      </div>
      <v-divider class="my-3"/>
      <template v-for="item in request.items">
        <div :key="item.id">
          <div class="d-flex justify-space-between text-small">
            <div class="d-flex flex-column">
              <span>{{ item.name }}</span>
              <span class="mt-1">{{ item.price | currency }} x {{ item.item_plan.quantity }}</span>
            </div>
            <span class="ml-3 font-weight-bold">{{ (+item.price * +item.item_plan.quantity) | currency }}</span>
          </div>
          <v-divider class="my-3"/>
        </div>
      </template>
      <div class="d-flex justify-space-between text-small">
        <span>Total</span>
        <span class="ml-3 font-weight-bold">{{ total | currency }}</span>
      </div>
    </div>

    <v-btn
      @click="views.menu = true" bottom class="mb-16" color="primary" elevation="1" fab fixed right
      style="transform: translateY(-10px) translateX(-15px)" v-if="$vuetify.breakpoint.smAndDown"
    >
      <v-icon>mdi-dots-horizontal</v-icon>
    </v-btn>

    <v-bottom-sheet inset max-width="500" right v-model="views.menu">
      <v-sheet class="px-4 py-8">
        <v-row>
          <v-col @click="$emit('open', 'schedule')" class="text-center py-8 cursor-pointer" cols="6">
            <v-icon color="blue">mdi-book</v-icon>
            <div class="text-small mt-1">Schedule</div>
          </v-col>
          <v-col class="text-center py-8 cursor-not-allowed disabled" cols="6">
            <v-icon color="orange">mdi-comment</v-icon>
            <div class="text-small mt-1">Make comment</div>
          </v-col>
          <v-col class="text-center py-8 cursor-not-allowed disabled" cols="6">
            <v-icon color="teal">mdi-account-search</v-icon>
            <div class="text-small mt-1">Analyze me</div>
          </v-col>
          <v-col class="text-center py-8 cursor-not-allowed disabled" cols="6">
            <v-icon color="purple">mdi-credit-card-plus</v-icon>
            <div class="text-small mt-1">Setup mandate</div>
          </v-col>
          <v-col @click="views.cancel = true" class="text-center py-8 cursor-pointer" cols="6" v-if="status < 2">
            <v-icon color="red">mdi-close</v-icon>
            <div class="text-small mt-1">Cancel request</div>
          </v-col>
        </v-row>
      </v-sheet>
    </v-bottom-sheet>

    <v-dialog max-width="350" persistent v-model="views.cancel">
      <v-card>
        <v-card-title>Are you sure?</v-card-title>
        <v-card-text>
          This action is irreversible and the link to this request will no longer work.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="views.cancel = false" color="green darken-1" text>No</v-btn>
          <v-btn @click="cancel()" color="red darken-1" text>Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RequestStatus from "./RequestStatus";

export default {
  name: "RequestInvoiceMobile",
  components: { RequestStatus },
  data() {
    return {
      request: this.$store.state.request,
      views: {
        menu: false,
        cancel: false
      }
    }
  },
  methods: {
    async cancel() {
      this.views.cancel = false
      const { request: { id: rid, creditclan_request_id }, merchant: { slug } } = this.$store.state
      await this.$http.delete(`https://sellbackend.creditclan.com/merchantclanbackend/public/index.php/api/request/${ rid }`)

      if (creditclan_request_id) {
        await this.$http.post(`https://mobile.creditclan.com/api/v3/cancel/loan_request`, { request_id: creditclan_request_id }, {
          headers: { 'x-api-key': 'WE4mwadGYqf0jv1ZkdFv1LNPMpZHuuzoDDiJpQQqaes3PzB7xlYhe8oHbxm6J228' }
        });
      }

      await this.$router.replace(`/${ slug }/collections`)
      this.$store.commit('request/clear')
    }
  },
  computed: {
    onCredit() {
      return this.$store.getters['request/credit'];
    },
    status() {
      return this.$store.state.request.req_status
    },
    total() {
      return this.request.items.reduce((acc, item) => {
        acc += (item.price * item.item_plan.quantity);
        return acc;
      }, 0)
    },
  }
}
</script>

<style lang="scss">
.bg-cart {
  position: absolute !important;
  bottom: -30px;
  left: calc(100% - 60px);
  transform: rotate(5deg);
  opacity: .1;
}
</style>
